const iterateOverPromises = (promiseFn, array, index = 0) => {
    if (!array.length || index >= array.length) return Promise.resolve();

    return promiseFn(array[index], index, array).then(() => iterateOverPromises(promiseFn, array, index + 1));
};

export default iterateOverPromises;
